interface UtilAllCauseProps {
  setDisplayValue: (val: number) => void;
  displayValue: number;
  clear: boolean;
  setClear: (val: boolean) => void;
  setIsFiltersOpen?: () => void;
}

const UtilAllCauseMenu: React.FC<UtilAllCauseProps> = ({
  setDisplayValue,
  displayValue,
  setClear,
  clear,
  setIsFiltersOpen,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(Number(event.target.value));
    setClear(false);
    setIsFiltersOpen?.();
  };
  return (
    <ul>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={66}
            checked={!clear && displayValue === 66}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Hospitalization{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={67}
            checked={!clear && displayValue === 67}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">
            Emergency Room{" "}
          </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={68}
            checked={!clear && displayValue === 68}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Urgent Care </span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={69}
            checked={!clear && displayValue === 69}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Outpatient</span>
        </label>
      </li>
      <li>
        <label className="label cursor-pointer justify-start ml-5">
          <input
            type="radio"
            className="radio radio-xs bg-white border-accent checked:radio-accent"
            value={70}
            checked={!clear && displayValue === 70}
            onChange={handleChange}
          />
          <span className="text-valmidnight text-base ml-2">Pharmacy</span>
        </label>
      </li>
    </ul>
  );
};

export default UtilAllCauseMenu;
